import "../Location.css";

const features = [
  "Free Consultation",
  "Competitive Rates",
  "Expert Technicians",
  "Quick Service",
];

const CheckIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21.8 10A10 10 0 1 1 17 3.3"></path>
    <path d="M9 11l3 3L22 4"></path>
  </svg>
);

const PhoneIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path>
  </svg>
);

const MailIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="4" width="20" height="16" rx="2"></rect>
    <path d="M22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
  </svg>
);

export default function CTASection() {
  return (
    <section className="cta-section">
      <div className="cta-bg-circle right"></div>
      <div className="cta-bg-circle left"></div>

      <div className="cta-container">
        <div className="cta-card">
          <div className="cta-content">

            <div className="cta-header">
              <h2 className="cta-title">
                Book Your Water Purifier
                <span>Today!</span>
              </h2>

              <p className="cta-description">
                Don't wait! Get the <strong>Best water purifier service</strong>{" "}
                at the most competitive rates. Contact{" "}
                <a href="/contact">rocareindia</a> today for a free consultation
                and quote.
              </p>
            </div>

            <div className="cta-features">
              {features.map((item) => (
                <div className="cta-feature" key={item}>
                  <CheckIcon />
                  <span>{item}</span>
                </div>
              ))}
            </div>

            <div className="cta-buttons">

              <a href="tel:9311587744" className="cta-btn">
                <div className="cta-btn-icon">
                  <PhoneIcon />
                </div>

                <span className="cta-btn-text">
                  +91-9311587744
                </span>
              </a>

              <a href="mailto:info@rocareindia.com" className="cta-btn">
                <div className="cta-btn-icon">
                  <MailIcon />
                </div>

                <span className="cta-btn-text">
                  info@rocareindia.com
                </span>
              </a>

            </div>

          </div>
        </div>
      </div>
    </section>
  );
}